import React from 'react';
import { useTranslation } from 'react-i18next';

interface ErrorMessageProps {
  message: string;
}

export const ErrorMessage: React.FC<ErrorMessageProps> = ({ message }) => {
  const { t } = useTranslation();
  if (!message) return null;

  return (
    <div className="bg-white border border-red-300 rounded-md p-4 mb-6">
      <div className="flex items-center">
        <div className="w-5 h-5 rounded-full bg-blue-600 mr-3"></div>
        <div>
          <h3 className="text-sm font-medium text-gray-900 m-0">{t('common.error')}</h3>
          <div className="mt-2 text-sm text-gray-500">{message}</div>
        </div>
      </div>
    </div>
  );
};
